import { IconButton } from "@castlery/fortress";
import { Loading, ShoppingBag } from "@castlery/fortress/Icons";

export const AddToCart = ({
  waitingForAddToCart,
  handleAddToCart,
}: {
  waitingForAddToCart: boolean;
  handleAddToCart: () => void;
}) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <IconButton
        className="transition-all duration-300"
        variant="image"
        size="md"
        sx={(theme) => ({
          border: "none",
          backgroundColor: theme.palette.brand.burntOrange[500],
          "&:hover": {
            backgroundColor: theme.palette.brand.burntOrange[600],
          },
          "&:pressed": {
            backgroundColor: theme.palette.brand.burntOrange[800],
          },
          cursor: waitingForAddToCart ? "not-allowed" : "pointer",
        })}
        onClick={() => handleAddToCart()}
      >
        {waitingForAddToCart ? (
          <Loading
            sx={(theme) => ({
              width: theme.spacing(4),
              height: theme.spacing(4),
              fill: theme.palette.brand.warmLinen[500],
              "@keyframes rotate": {
                from: {
                  transform: "rotate(0deg)",
                },
                to: {
                  transform: "rotate(360deg)",
                },
              },
              animation: "rotate .5s linear infinite",
            })}
          />
        ) : (
          <ShoppingBag
            sx={(theme) => ({
              width: theme.spacing(4),
              height: theme.spacing(4),
              fill: theme.palette.brand.warmLinen[500],
            })}
          />
        )}
      </IconButton>
    </div>
  );
};
